module.exports = __webpack_public_path__ + "img/single-select-icon.3f956344.svg";